import {
  EPTSessionType,
  EPTTimestampType,
  SearchEPTStartChannel,
  SearchEPTEndChannel,
  SearchEPTMarkChannel,
} from '@tableau/microview-communication-service/lib/src/channelDefinitions/SearchEPTChannelDefinitions';

export class SearchEPTService {
  public static instance = new SearchEPTService();

  public start(type: EPTSessionType, key: string) {
    const channel = new SearchEPTStartChannel();
    channel.call({ type, key });
  }

  public end(type: EPTSessionType, key: string) {
    const channel = new SearchEPTEndChannel();
    channel.call({ type, key });
  }

  public mark(type: EPTSessionType, key: string, timestampType: EPTTimestampType) {
    const channel = new SearchEPTMarkChannel();
    channel.call({ type, key, timestampType });
  }
}
